import angular from 'angular';
import './detail.component.js';
import './json.component.js';
import './events.component.js';

class DocrepoInvoiceTabsCtrl {
  /*@ngInject*/
  constructor(logger, DOCUMENT_FILTER_CONST, DocrepoInvoicesSvc) {
    this.logger = logger;
    this.DOCUMENT_FILTER_CONST = DOCUMENT_FILTER_CONST;
    this.DocrepoInvoicesSvc = DocrepoInvoicesSvc;
  }

  $onInit() {
    let vm = this;

    if (vm.invoice) {
      vm.loadJson();
      vm.loadEvents();
    } else if (vm.guid) {
      vm.loadInvoiceByGuid();
    }
  }

  loadInvoiceByGuid() {
    let vm = this;
    var options = [vm.DOCUMENT_FILTER_CONST.option.sellerInfo, vm.DOCUMENT_FILTER_CONST.option.buyerInfo];

    vm.DocrepoInvoicesSvc.searchInvoiceByGuid(vm.guid, options).then(
      function(data) {
        if (data.invoices.length > 0) {
          vm.invoice = data.invoices[0];
          vm.loadJson();
          vm.loadEvents();
        } else {
          vm.logger.error('invoice.unknown');
        }
      },
      function() {
        vm.logger.error('error.generic');
      }
    );
  }

  /**
   * Charge le Json complet de la facture depuis la docrepo.
   */
  loadJson() {
    let vm = this;
    vm.DocrepoInvoicesSvc.getDocumentJson(vm.guid).then(function(data) {
      vm.json = data;
      vm.jsonLoaded = true;
    });
  }

  /**
   * Charge tous les évènements de la facture depuis la docrepo.
   */
  loadEvents() {
    let vm = this;
    vm.DocrepoInvoicesSvc.getDocumentEvents(vm.guid).then(function(data) {
      vm.events = data;
      vm.eventsLoaded = true;
    });
  }
}

angular.module('app.docrepo_invoice').component('docrepoInvoiceTabs', {
  templateUrl: require('./docrepo-invoice-tabs.html'),
  controller: DocrepoInvoiceTabsCtrl,
  bindings: {
    invoice: '<', // Facture
    guid: '<' // Guid de la facture. Utile si on entre directement un guid dans l'url
  }
});
